import { ErrorBoundary } from 'react-error-boundary';

import { FallbackError } from '@/components/fallback-error/fallback-error';
import { SuspenseBoundary } from '@/components/SuspenseBoundary';
import { useFileById } from '@/hooks/useFileById';

type DownloableFileInfoProps = {
  fileInfoId: string;
  className?: string;
};

export const DownloableFileInfo = ({ fileInfoId, className }: DownloableFileInfoProps) => (
  <ErrorBoundary fallback={<FallbackError />}>
    <SuspenseBoundary>
      <DownloableFileInfoContent fileInfoId={fileInfoId} className={className} />
    </SuspenseBoundary>
  </ErrorBoundary>
);

const DownloableFileInfoContent = ({ fileInfoId, className }: DownloableFileInfoProps) => {
  const { data } = useFileById(fileInfoId);

  if (!data) return null;

  return (
    <a
      href={data.url}
      download
      target='_blank'
      rel='noopener noreferrer'
      className={`typography-body2 flex items-center gap-1 ${className ?? ''}`}
    >
      <i className='ri-download-line' />
      <span className='underline'>{data.visible_filename}</span>
    </a>
  );
};
